module.exports = __webpack_public_path__ + "img/section3_img4.6286cb2d.png";